/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};

(function () {
  'use strict';
  
  app.helpers.HtmlHelper = {
    /**
     * Форматирует единицу измерения
     * @param {string} name
     * @returns {*} исходная, либо отформатированная строка с разметкой
     */
    formatUnit: function (name) {
      if (name == 'м2') {
        name = 'м<sup class="sup-unit">2</sup>';
      }
      return name;
    },
  };
})();

}.call(window));